import { cn } from '@/lib/utils';

interface ConfidenceBarProps {
  confidence: number;
  className?: string;
  showLabel?: boolean;
}

export function ConfidenceBar({ confidence, className, showLabel = true }: ConfidenceBarProps) {
  const getColor = () => {
    if (confidence >= 70) return 'bg-emerald-500';
    if (confidence >= 50) return 'bg-amber-500';
    return 'bg-red-500';
  };

  return (
    <div className={cn('space-y-2', className)}>
      {showLabel && (
        <div className="flex items-center justify-between text-sm">
          <span className="font-medium">Confidence</span>
          <span className="font-semibold">{Math.round(confidence)}%</span>
        </div>
      )}
      <div className="h-2 w-full overflow-hidden rounded-full bg-muted">
        <div
          className={cn('h-full transition-all duration-500', getColor())}
          style={{ width: `${confidence}%` }}
        />
      </div>
    </div>
  );
}
